const getDocumentTypeName = (docTypeOptions = [], docType) =>
  docTypeOptions.find((opt) => opt.value === docType)?.display_name ?? "";

export default getDocumentTypeName;
